import { Avatar, Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { stringAvatar } from '../../../utils'
import { userListStyles } from './style'

export const UserList = ({ userData = {}, }) => {
    const classes = userListStyles()
    return (
        <Box>
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
                <Avatar className={classes.user_avatar} src={userData?.image}  {...stringAvatar(userData?.name)} />
                <Stack alignItems={"left"} sx={{ marginInlineStart: "8px !important" }}>
                    <Typography className={classes.name}> {userData?.name} </Typography>
                    {/* <Typography className={classes.role}> {userData?.sub_title} </Typography> */}
                    <Typography className={classes.role}> {userData?.sub_title1} </Typography>
                </Stack>
            </Stack>
        </Box>
    )
}